export default __webpack_public_path__ + "static/media/img-0278-malta-full-face.b48b0275.png";